module.exports = __webpack_public_path__ + "static/media/icon-new.ebbe32e0.png";